import "../../assets/css/login/login.css"

import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import Axios from "axios"

import prodensaData from "../../assets/images/prodensa_data.jpg"
import worldTeaser from "../../assets/images/teaser_world.jpg"
import { APP_ROUTES, EMAIL_REGEX, sweetAlertLoading } from "../../utils/globalUtils.js";
import { useAuth } from "../../context/auth-context.jsx";

const LOGIN_URI = process.env.REACT_APP_TEASER_LOGIN

export default function Login() {
    const [email, setEmail] = useState("")
    const { updateVerificationCode } = useAuth()

    const navigate = useNavigate()
    const url = useLocation()

    const referralCode = useMemo(() => {
        const searchParams = new URLSearchParams(url.search)
        const referralCode = searchParams.get("referralCode") ?? ""
        return referralCode
    }, [url])

    async function handleLogin() {
        if (!EMAIL_REGEX.test(email)) {
            Swal.fire({
				icon: "error",
				title: "Introduce a valid email",
				showConfirmButton: false,
				showCancelButton: false,
				timer: 2500,
				timerProgressBar: true,
			});

            return
        }

        sweetAlertLoading()

        Axios.post(LOGIN_URI, { email, referralCode }).then(res => {
            if (res.data?.isFinish) {
                Swal.fire({
                    icon: "error",
                    title: res.data.message,
                    showConfirmButton: false,
                    showCancelButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });

                return
            }

            updateVerificationCode(res.data)
    
            Swal.close()
            navigate(APP_ROUTES.auth)
        }).catch(err => {
            Swal.fire({
                icon: "error",
                title: err?.response?.data?.message || "Error trying to log in",
                showConfirmButton: false,
                showCancelButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
            console.log(err?.response?.data?.message || "Error trying to log in")
        })
        
    }

    function handleEmail (e) {
        const { value } = e.target

        setEmail(value)
    }


    return (
        <section className="loginSection">
            <img id="login-prodensa-data" src={prodensaData} alt="Prodensa Teaser" />
            <img id="login-teaser-word" src={worldTeaser} alt="Prodensa Teaser" />
            
            <div className="form-container">
                <h3 className="title">Create Demo Report</h3>
                
                <span className="disclaimer">The information, data, and results presented in this study are not precise, as they are provisional data.Please note that in this demo, only 9 cities from the country are being considered. For a comprehensive study with up-to-date data and information, kindly contact us at consulting@prodensa.com.</span>
                
                <div className="inputContainer">
                    <label htmlFor="email">Email</label>
                    <input type="text" id="email" value={email} onChange={handleEmail}/>
                </div>
                
                <button className="btnBgBlueTextGradient" onClick={handleLogin} disabled={!EMAIL_REGEX.test(email)}>Start</button>
            </div>
        </section>
    )
}